export default {
  getProductPrice: (state) => state.productPrice,
};
